export enum RebateRecordValidationErrorCodeModel {
	Format = 2,
	Required = 3,
	RecommendedFormat = 4
}
